<template>
    <div>
        <div v-if="!show_add_chapter &&!show_edit_chapter" class="create-box">
            <div class="create-box-title">
                <h3>编辑课程</h3>
            </div>
            <Form :model="editForm" label-position="left" :label-width="110">
                <FormItem label="课程环境" class="form-item">
                    {{mcp_info.mcp_type_name}}
                </FormItem>
                <FormItem label="课程名称" class="form-item">
                    <Input v-model="editForm.course_name" style="width: 200px" placeholder="请输入课程名称"></Input>
                </FormItem>
                <FormItem label="创建人" class="form-item">
                    {{user_info.nickname}}
                </FormItem>
                <!--                <FormItem label="课程权限" class="form-item">-->
                <!--                    <RadioGroup v-model="editForm.course_limit">-->
                <!--                        <Radio label="2">仅教师可见</Radio>-->
                <!--                        <Radio label="1">全校可见</Radio>-->
                <!--                    </RadioGroup>-->
                <!--                </FormItem>-->
                <FormItem label="课时数" class="form-item">
                    <Input v-model="editForm.course_hour" style="width: 200px" type="number"></Input>
                </FormItem>
                <FormItem label="所属方向">
                    <CheckboxGroup v-model="editForm.directions">
                        <Checkbox :label="item.id" v-for="(item,idx) in direction_info" :key="idx">
                            <span>{{item.name}}</span>
                        </Checkbox>
                    </CheckboxGroup>
                </FormItem>
                <FormItem label="难度标签" class="form-item">
                    <RadioGroup v-model="editForm.course_type">
<!--                        <Radio label="1">基础</Radio>-->
                        <Radio label="2">专业</Radio>
<!--                        <Radio label="3">核心</Radio>-->
                        <Radio label="4">实训</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="学分" class="form-item">
                    <Input v-model="editForm.score" style="width: 200px" type="number"></Input>
                </FormItem>
                <FormItem label="课程封面" class="form-item">
                    <Select v-model="cover" style="width: 200px">
                        <Option value="1">默认封面</Option>
                        <Option value="2">上传</Option>
                    </Select>
                    <div v-show="cover == '2'" class="upload-box">
                        <!-- <Upload :action="coverUrl"
                                name="cover_file"
                                :format="['jpg','png','bmp','gif','webp']"
                                :on-format-error="imgFormatError"
                                :on-success="coverSuccess"
                                :on-error="courseErr"
                                :on-progress="coverProgress"
                                :before-upload="coverBeforeUpload"
                        >
                            <Button icon="ios-cloud-upload-outline" @click="coverBtn">上传</Button>
                        </Upload> -->

                        <uploadComm
                            :action="coverUrl"
                            name="cover_file"
                            :format="['jpg','png','bmp','gif','webp','jpeg']"
                            accept=".jpg,.png,.bmp,.gif,.webp,.jpeg"
                            :uploadFunc="coverBtn"
                            :onSuccess="coverSuccess"
                            :onError="courseErr"
                            :onProgress="coverProgress"
                            :beforeUpload="coverBeforeUpload"
                            :maxSize="1024*5"
                        >
                        </uploadComm>


                    </div>
                    <div v-if="coverImgData.id" class="cover-img-box">
                        <img :src="coverImgData.path">
<!--                        <div class="upload-img-cover">-->
<!--                            <Icon type="ios-trash-outline" @click.native="removeCover(coverImgData.id)"></Icon>-->
<!--                            <Icon type="ios-trash-outline" ></Icon>-->
<!--                            <span>{{coverImgData.name}}</span>-->
<!--                        </div>-->
                    </div>
                </FormItem>
<!--                <FormItem label="过期时间" class="form-item">-->
<!--                    <DatePicker type="date" placeholder="选择日期" style="width: 200px" :value="editForm.expire_date"-->
<!--                                @on-change="handleExpireDate"></DatePicker>-->
<!--                </FormItem>-->
                <FormItem label="资料" class="form-item">
                    <!-- <Upload :action="courseDataUrl"
                            name="course_data_file"
                            :show-upload-list="showUploadList"
                            :format="['pdf','ppt','pptx','word','docx','doc','xls','xlsx','mp4','zip','rar']"
                            :on-format-error="formatError"
                            :on-success="courseDataSuccess"
                            :on-error="courseDataErr"
                    >
                        <Button icon="ios-cloud-upload-outline" @click="courseDataBtn">选择文件</Button>
                        <span class="text-label">请选择大小不超过300M的文件，支持格式[pdf,ppt,pptx,word,docx,doc,xls,xlsx,mp4,zip,rar]，此讲义教案将开放给学生下载。</span>
                    </Upload> -->

                    <uploadComm
                            :uploadFunc="courseDataBtn"
                            :action="courseDataUrl"
                            name="course_data_file"
                            :showUploadList="showUploadList"
                            :format="['pdf','ppt','pptx','word','docx','doc','xls','xlsx','mp4','zip','rar']"
                            :onFormatError="formatError"
                            :onSuccess="courseDataSuccess"
                            :onError="courseDataErr"
                            :maxSize="1024*100"
                        >
                        </uploadComm>

                </FormItem>
                <FormItem label="" class="form-item" v-if="courseData">
                    <Table border
                           :columns="columns"
                           :data="courseData"
                           size="small"
                           width="600"
                    ></Table>
                </FormItem>
                <hr>
                <FormItem label="课程介绍" class="form-item">
                    <Input v-model="editForm.introduction" type="textarea" :autosize="{minRows: 4,maxRows: 6}"
                           placeholder="请输入课程介绍" style="width: 50%"></Input>
                </FormItem>
                <hr>
                <div class="create-box-title">
                    <h3>详细课程</h3>
                </div>
                <div class="exercises-list-box">
                    <ul>
                        <li class="exercises-item open" v-for="(item,index) in detailedCourse" :key="item.id">
                            <div class="exercises-item-title">
                                <span class="exercises-item-title-name">{{index+1}}、{{item.name}}</span>
                                <div class="exercises-item-title-operation" v-if="item.name">
                                    <a href="javascript:void(0)"
                                       @click="addChapte(index,item)">添加节</a>
                                    <a href="javascript:void(0)" class="ml15"
                                       @click="editChapte(index,item)">编辑</a>
                                    <a href="javascript:void(0)" class="ml15"
                                       @click="deleteChapte(index,item.id)">删除</a>
                                </div>
                            </div>
                            <div v-if="item.subsections">
                                <div  class="lesson" v-for="(ite,idx) in item.subsections" :key="idx">
                                    <div class="lesson-inner" >
                                        <div  class="arrow-icon">
                                            <i ></i>
                                        </div>
                                        <div class="name">
                                            <span >{{idx+1}}、{{ite.name}}</span>
                                        </div>
                                        <div class="action-btn">
                                            <a href="javascript:void(0)" @click="editSubsec(ite,idx,index)">编辑</a>
                                            <a href="javascript:void(0)" @click="delSubsec(ite)">删除</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="exercises-item open">
                            <div class="exercises-item-title">
                                <span class="exercises-item-title-name">
                                    <a href="javascript:void(0)" @click="addChapter">
                                        <Icon type="ios-add" size="16"/>添加章
                                    </a>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <hr>
            </Form>
            <div class="btn-box">
                <Button type="primary" @click="createCourse('1')">保存</Button>
                <!--                <Button class="ml15" @click="createCourse('2')">保存并发布</Button>-->
                <Button class="ml15" @click="cancel">取消</Button>
            </div>
        </div>
        <div v-else-if="show_edit_chapter">
            <edit-chapter :chapter_id="chapter_id" :order="order" :subsec_id="subsec_id" :subsecIdx="subsecIdx" :mcp-info="mcp_info" ></edit-chapter>
        </div>
        <div v-else-if="show_add_chapter">
            <add-chapter :chapter_id="chapter_id" :order="order" :mcp-info="mcp_info" ></add-chapter>
        </div>
        <Modal
                v-model="addChapterModel"
                title="章节名称"
                width="450"
                @on-ok="ok"
        >
            <p>
                <span style="margin-right: 20px">章节名称</span>
                <Input v-model="addChapterName" style="width: 200px" placeholder="请输入章节名称"></Input>
            </p>

        </Modal>
        <Modal
                v-model="editChapterModel"
                title="编辑章节"
                width="450"
                @on-ok="okEdit"
        >
            <p>
                <span style="margin-right: 20px">章节名称</span>
                <Input v-model="editChapterName" style="width: 200px" placeholder="请输入章节名称"></Input>
            </p>

        </Modal>
    </div>
</template>

<script>
    import editChapter from "./editChapter";
    import addChapter from "./addChapter";
    import {authApi} from '@/api/base.js'
    import {mapActions, mapState} from 'vuex'
    import cookie from "vue-cookies";
    import uploadComm from '@/components/upload/upload'

    export default {
        name: "editCourse",
        components: {
            editChapter,
            addChapter,
            uploadComm
        },
        props: {
            course_id: Number,
            mcp_type:{
                type:Number,
                required:true,
            },
            mcp_info:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                show_add_chapter: false,
                show_edit_chapter: false,
                addChapterModel: false,
                editChapterModel: false,
                courseTableShow: false,
                showUploadList:true,
                questionType: '',
                coverUrl: '',
                coverImgData: {},
                courseDataUrl: '',
                coverData: {},
                cover: '1',
                chapter_id: null,
                subsec_id: null,
                subsecIdx:null,
                order: null,
                editForm: {
                    course_name: '',
                    course_limit: '2',
                    course_hour: '',
                    course_type: '1',
                    course_nature: '1',
                    score: '',
                    directions: [],
                    introduction: '',
                    // expire_date: '',
                    cover_id: '',
                    chapter_ids: [],
                    course_data_ids: [],
                },
                addChapterName: '',
                editChapterName: '',
                editChapterIdx: null,
                detailedCourse: [],
                courseData: [],
                columns: [
                    {
                        title: '文件名',
                        key: 'name',
                        align: 'center',
                        tooltip: true
                    },
                    {
                        title: '大小',
                        key: 'size',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        marginRight: '5px',
                                    }
                                }, params.row.size),
                            ]);
                        }
                    },
                    // {
                    //     title: '状态',
                    //     key: 'status',
                    //     align: 'center'
                    // },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color: '#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.courseData.splice(params.index, 1)
                                            this.delCourseData(params.row.id)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                    // {
                    //     title: '是否同步到资源广场',
                    //     key: 'is_open',
                    //     align: 'center',
                    //     render: (h, params) => {
                    //         return h('div',[
                    //             h('i-switch',{
                    //               props:{
                    //                   value:params.row.is_open,
                    //                   trueValue:2,
                    //                   falseValue:1,
                    //                 // type:params.row.is_open == 2 ?'primary':'default',
                    //                 // size:"small"
                    //               },
                    //               // domProps:{
                    //               //   innerHTML:'是'
                    //               // },
                    //               // style: {
                    //               //   marginRight: '5px',
                    //               // },
                    //               on:{
                    //                 // click: () => {
                    //                 //   this.changeSwitch(2,params.row)
                    //                 // }
                    //                   'on-change':(value)=>{
                    //                       let param = value?2:1;
                    //                       this.changeSwitch(param,params.row)
                    //                   }
                    //               }
                    //             }),
                    //             // h('Button',{
                    //             //   props:{
                    //             //     type:params.row.is_open == 1 ?'primary':'default',
                    //             //     size:"small"
                    //             //   },
                    //             //   domProps:{
                    //             //     innerHTML:'否'
                    //             //   },
                    //             //   on:{
                    //             //     click: () => {
                    //             //       this.changeSwitch(1,params.row)
                    //             //     }
                    //             //   }
                    //             // })
                    //           ])
                    //     }
                    // },
                ]
            }
        },
        computed: {
            ...mapState({
                user_info: state => state.loginState.user_info,
                direction_info: state => state.courseManage.direction_info,
                cur_chapter_info: state => state.courseManage.cur_chapter_info
            })
        },
        methods: {
            ...mapActions({
                edit_course: 'courseManage/edit_course',
                getCurCourseInfo: 'courseManage/getCurCourseInfo',
                createChapter: 'courseManage/createChapter',
                getDirection: 'courseManage/getDirection',
                editCourseData: 'courseManage/editCourseData',
                delCourseData: 'courseManage/delCourseData',
                delChapter: 'courseManage/delChapter',
                editChapter: 'courseManage/editChapter',
                delCover: 'courseManage/delCover',
                getChapter: 'courseManage/getChapter',
                delSubsection:'courseManage/delSubsection'
            }),
            handleExpireDate(date) {
                this.editForm.expire_date = date
            },
            addChapter() {
                this.addChapterName = ''
                this.addChapterModel = true
            },
            formatError(){
              this.$Message.error('文件格式错误，请上传正确的格式文件！');
            },
            deleteChapte(index, chapter_id) {
                this.delChapter(chapter_id)
                this.detailedCourse.splice(index, 1)
            },
            editChapte(index, item) {
                this.editChapterName = item.name
                this.chapter_id = item.id
                this.editChapterIdx = index
                this.editChapterModel = true
            },
            //添加节
            addChapte(index,item) {
                this.chapter_id = item.id
                this.order = index
                this.show_add_chapter = true
            },
            okEdit() {
                let _this = this
                this.detailedCourse[this.editChapterIdx].name = this.editChapterName
                this.editChapter({
                    chapter_id: _this.chapter_id,
                    data: {
                        name: _this.editChapterName,
                        order: _this.editChapterIdx
                    },
                    callback:res =>{
                        if(res.status.code === 2000000){
                            _this.$Message.success(res.status.message);
                        }else{
                            _this.$Message.error(res.status.message);
                        }
                    }
                })
            },
            //删除封面
            removeCover(id) {
                let _this = this
                this.delCover({
                    cover_id: id,
                    callback: res => {
                        _this.$Message.success(res.message);
                        _this.coverImgData = {}
                    }
                })
            },
            //上传课程讲义按钮
            courseDataBtn() {
                let access_token = cookie.get('session')
                this.showUploadList = true
                this.courseDataUrl = `${authApi}api-course/tm/course/data?access_token=${access_token}`
            },
            //上传封面按钮
            coverBtn() {
                let access_token = cookie.get('session')
                this.coverUrl = `${authApi}api-course/tm/course/cover?access_token=${access_token}`
            },
            //封面上传成功
            coverSuccess(response) {
                if (response.status.code == 2000000) {
                    this.editForm.cover_id = response.body.cover_id
                }
            },
            courseErr(){
                this.$Message.error('封面上传失败，请稍后再试！');
            },
            imgFormatError(){
                this.$Message.error('文件格式错误，请上传正确的图片格式文件！');
            },
            courseDataSuccess(response) {
                if (response.status.code == 2000000) {
                    this.courseTableShow = true
                    this.showUploadList = false
                    this.courseData.push({
                        id: response.body.course_data_id,
                        name: response.body.filename,
                        size: `${response.body.filesize}M`,
                        status: '上传成功'
                    })
                    this.editForm.course_data_ids.push(response.body.course_data_id)
                }else{
                    this.$Message.error(response.status.message)
                }
            },
            courseDataErr(err,file, fileList){
                this.$Message.error(file.message)
            },
            coverProgress(event, file, fileList) {

            },
            coverBeforeUpload(response) {
                this.coverData.cover_file = response.name
            },
            ok() {
                let _this = this
                this.createChapter({
                    name: _this.addChapterName,
                    order: _this.order,
                    callback: res => {
                        _this.editForm.chapter_ids.push(res.chapter_id)
                        _this.detailedCourse.push({
                            id: res.chapter_id,
                            name: res.chapter_name,
                            subsections:[]
                        })
                    },
                    error: res => {
                        if(res){
                            _this.$Message.error(res);
                        }
                    }
                })


            },
            //是否同步资源广场
            changeSwitch(status, row) {
                let _this = this
                this.editCourseData({
                    course_data_id: row.id,
                    data: {
                        is_open: status
                    },
                  callback:res =>{
                    _this.$Message.success(res.message);
                    row.is_open = status
                  },
                  err:msg =>{
                    _this.$Message.error({
                      content: msg,
                      duration:4
                    });
                  }
                })
            },
            createCourse() {
                let _this = this
                // 修改封面参数
                if(_this.cover == 1) _this.editForm.cover_id = 1;
                this.edit_course({
                    data: {
                        data: _this.editForm,
                        course_id: _this.course_id
                    },
                    callback:res =>{
                        _this.$Message.success('修改成功！');
                        _this.cancel()
                    },
                    error:msg =>{
                        _this.$Message.error({
                            content: msg,
                            duration:4
                        });
                    }
                })
            },
            cancel() {
                this.$parent.edit_course = false
                this.editForm = {
                    course_name: '',
                    course_limit: '2',
                    course_hour: '',
                    course_type: '1',
                    course_nature: '1',
                    score: '',
                    directions: [],
                    introduction: '',
                    // expire_date: '',
                    cover_id: '',
                    chapter_ids: [],
                    course_data_ids: [],
                }
            },
            initEditForm(res) {
                let _this = this
                if (res) {
                    this.editForm.course_name = res.course_name
                    this.editForm.course_limit = res.course_limit
                    this.editForm.course_hour = res.course_hour
                    this.editForm.course_type = String(res.course_type)
                    this.editForm.course_nature = res.course_nature
                    this.editForm.score = res.score
                    this.editForm.directions = res.directions
                    this.editForm.introduction = res.introduction
                    // this.editForm.expire_date = res.expire_date
                    this.editForm.cover_id = res.cover_id
                    this.cover = res.cover_id == 1 ? "1" : "2"
                    this.coverImgData = res.cover
                    if(res.course_datas){
                        this.courseData = res.course_datas
                        this.courseData.forEach(item =>{
                            _this.editForm.course_data_ids.push(item.id)
                        })
                    }
                }
            },
            //编辑小节
            editSubsec(item,index,orderIdx){
                this.order = orderIdx
                this.subsecIdx = index
                this.subsec_id = item.id
                this.chapter_id = item.chapter_id
                this.show_edit_chapter = true

            },
            //删除小节
            delSubsec(item){
                let _this = this
                this.delSubsection({
                    subsec_id:item.id,
                    callback:res =>{
                        _this.$Message.success(res.status.message);
                        _this.initChapter()
                    }

                })
            },
            copy (data) {
                return JSON.parse(JSON.stringify(data))
            },
            initChapter(){
                let _this = this
                _this.editForm.chapter_ids = []
                this.getChapter({
                    course_id:_this.course_id,
                    callback: res => {
                        let resData = _this.copy(res)
                        resData.forEach(item =>{
                            _this.editForm.chapter_ids.push(item.id)
                        })
                        _this.detailedCourse = resData
                    }
                })
            }
        },
        mounted() {
            let _this = this
            this.getDirection()
            this.getCurCourseInfo({
                course_id: _this.course_id,
                callback: res => {
                    let resData = _this.copy(res)
                    _this.initEditForm(resData)
                }
            })
            this.initChapter()

        },
        watch: {
            'show_add_chapter':function(val){
                if(!val){
                    // this.initChapter()
                }

            },
            'show_edit_chapter':function(val){
                if(!val){
                    // this.initChapter()
                }

            }
        },
    }
</script>
<style lang="less">
    .create-box {
        .ivu-upload-list {
            display: inline-block;
            vertical-align: middle;
        }

        .ivu-table-cell {
            padding: 0;
        }
    }

</style>
<style scoped lang="less">
    @import "../../style/index";
    @import "../../../../assets/style/exercises";
    .cover-img-box {
        margin: 15px 0;
        width: 240px;
        height: 128px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        .upload-img-cover {
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, .6);
            text-align: center;

            span {
                display: block;
                color: #ffffff;
            }
        }

        .upload-img-cover i {
            color: #fff;
            font-size: 30px;
            cursor: pointer;
            margin-top: 40px;
        }
    }

    .cover-img-box:hover .upload-img-cover {
        display: block;
    }
</style>
